/**
 * Generated from ch8_p01.fla
 */
export function ch8_p01(this: Ich8_p01) {
	const letters = this.letters;
	if (!letters[0] && letters.elementFactory) {
		letters[0] = letters.elementFactory(0,undefined);
	}
	if (letters[0]) {
		ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_textb.call(letters[0] as Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_textb);
		letters[0].x = 414.5;
		letters[0].y = 272.75;
		letters[0].width = 114.00;
		letters[0].height = 160.50;
		letters[0].alpha = 1;
		if (letters[0].onLayout) letters[0].onLayout();
	}
	if (!letters[1] && letters.elementFactory) {
		letters[1] = letters.elementFactory(1,undefined);
	}
	if (letters[1]) {
		ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_1.call(letters[1] as Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_1);
		letters[1].x = 525.25;
		letters[1].y = 217.75;
		letters[1].width = 103.50;
		letters[1].height = 208.50;
		letters[1].alpha = 1;
		if (letters[1].onLayout) letters[1].onLayout();
	}
	if (!letters[2] && letters.elementFactory) {
		letters[2] = letters.elementFactory(2,undefined);
	}
	if (letters[2]) {
		ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_2.call(letters[2] as Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_2);
		letters[2].x = 637.5;
		letters[2].y = 177;
		letters[2].width = 108.00;
		letters[2].height = 218.00;
		letters[2].alpha = 1;
		if (letters[2].onLayout) letters[2].onLayout();
	}
	if (!letters[3] && letters.elementFactory) {
		letters[3] = letters.elementFactory(3,undefined);
	}
	if (letters[3]) {
		ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_3.call(letters[3] as Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_3);
		letters[3].x = 742;
		letters[3].y = 148;
		letters[3].width = 80.00;
		letters[3].height = 206.00;
		letters[3].alpha = 1;
		if (letters[3].onLayout) letters[3].onLayout();
	}
	if (!letters[4] && letters.elementFactory) {
		letters[4] = letters.elementFactory(4,undefined);
	}
	if (letters[4]) {
		ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_4.call(letters[4] as Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_4);
		letters[4].x = 856.25;
		letters[4].y = 156;
		letters[4].width = 93.50;
		letters[4].height = 212.00;
		letters[4].alpha = 1;
		if (letters[4].onLayout) letters[4].onLayout();
	}
	if (!letters[5] && letters.elementFactory) {
		letters[5] = letters.elementFactory(5,undefined);
	}
	if (letters[5]) {
		ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_5.call(letters[5] as Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_5);
		letters[5].x = 966.25;
		letters[5].y = 172.25;
		letters[5].width = 77.50;
		letters[5].height = 176.50;
		letters[5].alpha = 1;
		if (letters[5].onLayout) letters[5].onLayout();
	}
	if (!letters[6] && letters.elementFactory) {
		letters[6] = letters.elementFactory(6,undefined);
	}
	if (letters[6]) {
		ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_6.call(letters[6] as Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_6);
		letters[6].x = 1068.75;
		letters[6].y = 184.5;
		letters[6].width = 75.50;
		letters[6].height = 168.00;
		letters[6].alpha = 1;
		if (letters[6].onLayout) letters[6].onLayout();
	}
	if (!letters[7] && letters.elementFactory) {
		letters[7] = letters.elementFactory(7,undefined);
	}
	if (letters[7]) {
		ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_7.call(letters[7] as Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_7);
		letters[7].x = 1156.75;
		letters[7].y = 201;
		letters[7].width = 62.50;
		letters[7].height = 155.00;
		letters[7].alpha = 1;
		if (letters[7].onLayout) letters[7].onLayout();
	}
	if (!letters[8] && letters.elementFactory) {
		letters[8] = letters.elementFactory(8,undefined);
	}
	if (letters[8]) {
		ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_8.call(letters[8] as Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_8);
		letters[8].x = 1234.25;
		letters[8].y = 210.75;
		letters[8].width = 63.50;
		letters[8].height = 139.50;
		letters[8].alpha = 1;
		if (letters[8].onLayout) letters[8].onLayout();
	}
	if (!letters[9] && letters.elementFactory) {
		letters[9] = letters.elementFactory(9,undefined);
	}
	if (letters[9]) {
		ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta.call(letters[9] as Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta);
		letters[9].x = 1294.25;
		letters[9].y = 209.5;
		letters[9].width = 39.50;
		letters[9].height = 101.00;
		letters[9].alpha = 1;
		if (letters[9].onLayout) letters[9].onLayout();
	}
	const sheep = this.sheep;
	if (!sheep[0] && sheep.elementFactory) {
		sheep[0] = sheep.elementFactory(0,undefined);
	}
	if (sheep[0]) {
		ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_1.call(sheep[0] as Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_1);
		sheep[0].x = 1073;
		sheep[0].y = 662;
		sheep[0].width = 346.00;
		sheep[0].height = 302.00;
		sheep[0].alpha = 1;
		if (sheep[0].onLayout) sheep[0].onLayout();
	}
	if (!sheep[1] && sheep.elementFactory) {
		sheep[1] = sheep.elementFactory(1,undefined);
	}
	if (sheep[1]) {
		ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_2.call(sheep[1] as Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_2);
		sheep[1].x = 1321.75;
		sheep[1].y = 649.5;
		sheep[1].width = 327.50;
		sheep[1].height = 284.50;
		sheep[1].alpha = 1;
		if (sheep[1].onLayout) sheep[1].onLayout();
	}
	if (!sheep[2] && sheep.elementFactory) {
		sheep[2] = sheep.elementFactory(2,undefined);
	}
	if (sheep[2]) {
		ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_3.call(sheep[2] as Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_3);
		sheep[2].x = 1117.25;
		sheep[2].y = 634;
		sheep[2].width = 320.50;
		sheep[2].height = 324.00;
		sheep[2].alpha = 1;
		if (sheep[2].onLayout) sheep[2].onLayout();
	}
	const bg = this.bg;
	ch8_p01_hh_ch8_72dpi_p01psdAssetchp1_p01_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const textbg = this.textbg;
	ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_textchp8_p01_textbg.call(this.textbg);
	textbg.x = 856.25;
	textbg.y = 226.75;
	textbg.width = 1056.50;
	textbg.height = 453.50;
	textbg.alpha = 1.00;
	if (textbg.onLayout) textbg.onLayout();
	const pen = this.pen;
	ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_pen.call(this.pen);
	pen.x = 1232.5;
	pen.y = 515.5;
	pen.width = 863.00;
	pen.height = 329.00;
	pen.alpha = 1.00;
	if (pen.onLayout) pen.onLayout();
	const grass = this.grass;
	ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_grass.call(this.grass);
	grass.x = 832;
	grass.y = 595;
	grass.width = 1664.00;
	grass.height = 346.00;
	grass.alpha = 1.00;
	if (grass.onLayout) grass.onLayout();
	const holly = this.holly;
	ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_holly.call(this.holly);
	holly.x = 747;
	holly.y = 669.5;
	holly.width = 161.00;
	holly.height = 560.50;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const frameRight = this.frameRight;
	ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 351.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframerlines.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 526;
	linesRight.width = 113.50;
	linesRight.height = 281.00;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 345.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframellines.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 577;
	linesLeft.width = 64.00;
	linesLeft.height = 282.00;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp1_p01_bg(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp1_p01_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp1_p01_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_textchp8_p01_textbg(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_textchp8_p01_textbg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p01_textbg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_textb(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_textb) {
	if (this.setLayoutTexture) this.setLayoutTexture("b", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_1(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("a_1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_2(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_2) {
	if (this.setLayoutTexture) this.setLayoutTexture("a_2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_3(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_3) {
	if (this.setLayoutTexture) this.setLayoutTexture("a_3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_4(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_4) {
	if (this.setLayoutTexture) this.setLayoutTexture("a_4", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_5(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_5) {
	if (this.setLayoutTexture) this.setLayoutTexture("a_5", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_6(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_6) {
	if (this.setLayoutTexture) this.setLayoutTexture("a_6", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_7(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_7) {
	if (this.setLayoutTexture) this.setLayoutTexture("a_7", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_8(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_8) {
	if (this.setLayoutTexture) this.setLayoutTexture("a_8", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta) {
	if (this.setLayoutTexture) this.setLayoutTexture("a", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_1(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("_1", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_2(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_2) {
	if (this.setLayoutTexture) this.setLayoutTexture("_2", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_3(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_3) {
	if (this.setLayoutTexture) this.setLayoutTexture("_3", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_pen(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_pen) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p01_pen", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_grass(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_grass) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p01_grass", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_holly(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p01_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframeRframe(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframerlines(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframerlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("rlines", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("multiply");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframeLframe(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframellines(this: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframellines) {
	if (this.setLayoutTexture) this.setLayoutTexture("llines", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich8_p01Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich8_p01Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich8_p01Sprite extends Ich8_p01Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich8_p01Text extends Ich8_p01Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich8_p01Polygon extends Array<number> {
}
interface Ich8_p01 {
	readonly letters: Ich8_p01Array<Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_textb|Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_1|Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_2|Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_3|Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_4|Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_5|Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_6|Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_7|Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_8|Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta>;
	readonly sheep: Ich8_p01Array<Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_1|Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_2|Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_3>;
	readonly bg: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp1_p01_bg;
	readonly textbg: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_textchp8_p01_textbg;
	readonly pen: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_pen;
	readonly grass: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_grass;
	readonly holly: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_holly;
	readonly frameRight: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframeRframe;
	readonly linesRight: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframerlines;
	readonly frameLeft: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframeLframe;
	readonly linesLeft: Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframellines;
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp1_p01_bg extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_textchp8_p01_textbg extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_textb extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_1 extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_2 extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_3 extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_4 extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_5 extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_6 extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_7 extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta_8 extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_texta extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_1 extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_2 extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_sheep_3 extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_pen extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_grass extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_holly extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframeRframe extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframerlines extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframeLframe extends Ich8_p01Sprite {
}
interface Ich8_p01_hh_ch8_72dpi_p01psdAssetchp8_p01_wcframellines extends Ich8_p01Sprite {
}
